import React, { type FC, type ReactNode, useContext } from 'react';
import { style } from 'typestyle';
import leftoverColumns from './grid.styles';
import Row from '../row/row.component';
import { IsMobileContext } from '../../context/is-mobile';
import { MainAxisAlignment } from '../flex/flex.component';

interface Props {
  readonly rowClass?: string;
  readonly itemSpacing?: number;
  readonly alignment?: MainAxisAlignment;
  readonly numberOfColumns: number;
  readonly numberOfItems: number;
  readonly gridColumnWidth?: number;
  readonly renderItem: (index: number) => ReactNode;
}

const Grid: FC<Props> = ({
  rowClass,
  itemSpacing,
  alignment,
  numberOfColumns,
  numberOfItems,
  gridColumnWidth,
  renderItem,
}): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);

  let contextualNumberOfColumns = numberOfColumns;

  if (isMobile) {
    contextualNumberOfColumns = 1;
  }

  const numberOfSections = Math.ceil(numberOfItems / contextualNumberOfColumns);
  const rows: ReactNode[] = [];

  for (let row = 0; row < numberOfSections; row += 1) {
    const columns: ReactNode[] = [];

    for (let col = 0; col < contextualNumberOfColumns; col += 1) {
      const itemIndex = row * contextualNumberOfColumns + col;

      if (itemIndex < numberOfItems) {
        columns.push(renderItem(itemIndex));
      } else {
        columns.push(<div key={itemIndex} className={style(leftoverColumns(gridColumnWidth))} />);
      }
    }

    rows.push(
      <Row key={row} className={rowClass} mainAxisAlignment={alignment ?? MainAxisAlignment.Stretch} itemSpacing={itemSpacing ?? 0}>
        {columns}
      </Row>,
    );
  }

  return <div>{rows}</div>;
};

export default Grid;
